import { types } from "mobx-state-tree";
import Agent from "./Agent";
import AgentTeam from "./AgentTeam";

const AgentStore = types
  .model("AgentStore", {
    agents: types.optional(types.array(Agent), []),
  })
  .actions((self) => ({
    setAgents(agents) {
      let newAgents = [];
      for (let agent of agents) {
        // reason code for the agent needs to just be the code as it is referencing a reason code in the store
        agent.reasonCode = agent.reasonCode
          ? agent.reasonCode.code
          : null;

        // status code for the agent also needs to just be the code
        agent.statusCode = agent.statusCode
          ? agent.statusCode.code
          : null;

        // set the agent teams array to store team agents models
        agent.teams = agent.teams.map((team) =>
          AgentTeam.create({ team: team.id, loggedIn: team.loggedIn })
        );

        agent.currentCallTeam = agent.currentCallTeam
          ? agent.currentCallTeam.id
          : null;

        newAgents.push(Agent.create(agent));
      }
      self.agents = [...newAgents];
    },
    addAgent(agent) {
     self.agents.push(Agent.create(agent));
    },
    removeAgents(agents) {
      agents.forEach((a) => {
        self.agents.remove(a);
      });      
    },
    updateAgent(id, data) {
      const agent = self.agents.find((a) => a.id === id);
      if (agent) {
        agent.update(data);
      }
    },
    setAgentLocationCode(id, code) {
      const agent = self.agents.find((a) => a.id === id);
      if (agent) {
        agent.setLocationCode(code);
      }
    },
    removeAgentTeams(teams) {
      const teamIds = teams.map((t) => t.id);
      self.agents.forEach((a) => {
        a.removeTeams(teamIds);
      });
    },
  }));

export default AgentStore;
